import { useRef } from 'react';
import { CaseCard, type CaseStudy } from '../../components/CaseCard';
import { SectionHeading } from '../../components/SectionHeading';
import { useSpotlight } from '../../hooks';

const CASES: CaseStudy[] = [
  {
    client: 'Prescient Security',
    tone: 'g-blue',
    logo: '/assets/logos/prescient.png',
    sector: 'Cybersecurity · US',
    title: 'SOC 2 controls testing, twice as fast',
    body: 'A controls-testing web application for a US cybersecurity organization: evidence collection and attachment, multi-stage audit checks, and complete report generation — replacing manual audit workflows.',
    metric: '+100%',
    metricLabel: 'controls-testing efficiency',
  },
  {
    client: 'TokyoMedic',
    tone: 'g-violet',
    logo: '/assets/logos/tokyomedic.png',
    sector: 'Medical equipment',
    title: 'An ERP for the whole operation',
    body: 'An extensive custom ERP for a medical equipment supplier, handling their business operations end to end — from orders and inventory to the workflows in between.',
    metric: 'End-to-end',
    metricLabel: 'operations on one system',
  },
  {
    client: '48by40',
    tone: 'g-pink',
    logo: '/assets/logos/48by40.svg',
    sector: 'International logistics',
    title: 'Every truck and container, accounted for',
    body: 'A web platform for an international logistics company tracking equipment from trucks to containers and heavy machinery — built for both sides of the lease, lessee and lessor.',
    metric: '2-sided',
    metricLabel: 'platform: lessee + lessor',
  },
  {
    client: 'Elevani Industries',
    tone: 'g-sun',
    logo: '/assets/logos/elevani.png',
    sector: 'Textile manufacturing',
    title: 'Onboarded to Lumen ERP',
    body: 'A textile company running its operations on Lumen, our modular ERP — configured to their processes instead of forcing them into someone else’s.',
    metric: 'Lumen',
    metricLabel: 'premium ERP, tailored fit',
  },
];

export function CaseStudies(): React.JSX.Element {
  const gridRef = useRef<HTMLDivElement>(null);
  useSpotlight(gridRef);

  return (
    <section id="work" className="section-surface">
      <div className="container">
        <SectionHeading
          anim="slide"
          title={
            <>
              Real systems, running in <span className="si accent-text">real businesses</span>.
            </>
          }
          lede="Medical supply, logistics, manufacturing, and cybersecurity — four systems running in production today."
        />
        <div className="case-grid" ref={gridRef}>
          {CASES.map((study, i) => (
            <CaseCard key={study.client} study={study} delay={(i % 2) + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}
